module.exports = __webpack_public_path__ + "tea_box_packaguing_design_mockup_moc_bilja_dr_josif_pancic.jpg?614145082390c722fcbb295fd7232888";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/tea_box_packaguing_design_mockup_moc_bilja_dr_josif_pancic.jpg
// module id = 85
// module chunks = 0